import { Box, Button, Flex, Text, Tooltip, VStack } from "@chakra-ui/react";
import { Icon } from "@chakra-ui/icons";
import { ComponentProps, ElementType, FC } from "react";
import { scrollBarStyle } from "../../../utils/styles/styles";
import { NO_RESULTS } from "../../../utils/constants";

interface Option {
  code: string | number;
  name: string;
  description: string;
}

interface FeatureListProps {
  setDataTable: (data: any) => void;
  dataTable: any[];
  features: Option[];
  onFeatureClick: (item: Option) => void;
  IconComponent: ElementType;
  IconInfo: ElementType;
  iconProps?: ComponentProps<typeof Icon>;
  isDisabled?: boolean;
}

const FeatureList: FC<FeatureListProps> = ({
  setDataTable,
  dataTable,
  features,
  onFeatureClick,
  IconComponent,
  IconInfo,
  iconProps,
  isDisabled,
}) => {
  const renderEmptyState = () => (
    <Box width="100%" display="flex" justifyContent="center">
      <Text mx={19.5} my={2.5} fontSize="sm">
        {NO_RESULTS}
      </Text>
    </Box>
  );

  const renderTable = () => {
    isDisabled && setDataTable(dataTable);
    return (
      <>
        {features.map((item, i) => (
          <Button
            key={i}
            onClick={(e) => {
              e.preventDefault();
              onFeatureClick(item);
            }}
            variant="pickList"
            px="0"
            py="4"
            isDisabled={isDisabled}
          >
            <Flex justifyContent="space-between" w="100%">
              <Flex alignItems="center">
                <Text fontSize="md">{item.name}</Text>
                {item.description && (
                  <Tooltip hasArrow label={item.description}>
                    <Flex ms={1}>
                      <Icon as={IconInfo} isDisabled={isDisabled} boxSize="5" />
                    </Flex>
                  </Tooltip>
                )}
              </Flex>
              <Icon as={IconComponent} {...iconProps} isDisabled={isDisabled} />
            </Flex>
          </Button>
        ))}
      </>
    );
  };

  const renderContent = () => {
    return features.length > 0 ? renderTable() : renderEmptyState();
  };

  return (
    <VStack
      spacing={2.5}
      align="stretch"
      w="100%"
      pl="1px"
      pr="2"
      maxH="400px"
      overflowY="auto"
      sx={{ ...scrollBarStyle, maxHeight: "400px" }}
    >
      {renderContent()}
    </VStack>
  );
};

export default FeatureList;
